import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://dev.api.schenck.one',
  apiBaseUrl: 'https://dev.api.schenck.one/am/v1', // against deployed/cloud backend
  usBaseUrl: 'https://dev.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://dev.api.schenck.one/um/v2/rights/AM',
  rmBaseUrl: 'https://dev.api.schenck.one/rm/v1',
  // apiBaseUrl: 'https://localhost:8080/v1', // against local backend
  googleApiKey: 'AIzaSyCaCOvpgCooOPqfq4yIgpasYKr2-k9xIWQ',
  versionInfo: {
    tag: 'dev',
    hash: 'ecf22a7b0059796879827be9b39cf682efd9b200',
    buildtimestamp: '2026-07-06T07:52:21.7675125Z',
    buildVersion: '4.0.0+2669',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: 'fc00be38-4b53-4911-9eeb-78e36a9faccc',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://dev.assetmanager.schenck.one/',
        postLogoutRedirectUri: 'https://dev.assetmanager.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/ed79441b-4a58-4429-b5cd-233d0f88de57/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
